import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_LISTAR_ATRAS } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import { actualizarVehiculo, obtenerInfoVehiculo } from "../../../api/api-vehiculo";
import Select from "react-select";
import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";
import { obtenerListaCombustible } from "../../../api/api-tipo-combustible";
import { obtenerListaVoltajeBateria } from "../../../api/api-voltaje-bateria";
import { obtenerListaTipoVehiculo } from "../../../api/api-tipo-vehiculo";
import { actualizarInfoEmpresa, obtenerInfoEmpresa } from "../../../api/api-empresa";
import moment from "moment";

const styles = {
    headerContainer: {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
    },
    line: {
        flex: 1,
        borderBottom: "1px solid #000",
    },
    headerText: {
        marginRight: "10px",
        fontWeight: "bold",
        fontSize: "16px",
    },
};

export default function Empresa() {

    const history = useHistory();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [titulo, setTitulo] = useState("INFORMACION EMPRESA");
    const [formData, setFormData] = useState({});
    // const [infoEmpresa, setInfoEmpresa] = useState({});

    const charLimits = {
        nombre: 128,
        direccion: 512,
        nit: 45,
        telefono: 45,
        nombreUsuario: 128,
    };

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {

            const response = await obtenerInfoEmpresa();
            console.log('response');
            console.log(response);
            setFormData(response.body);
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const handleSaveClick = async () => {
        // console.log('handleSaveClick');
        // lógica para guardar los cambios
        // console.log('formData');
        // console.log(formData);
        let objEnviar = formData;
        objEnviar.id = formData.id;
        objEnviar.nombre = formData.nombre;
        objEnviar.direccion = formData.direccion;
        objEnviar.telefono = formData.telefono;
        // console.log('objEnviar');
        // console.log(objEnviar);
        // return;
        if (objEnviar.id !== 0) {
            // console.log('actualizar correo');
            const response = await actualizarInfoEmpresa(objEnviar);
            // console.log('modificado');
            // console.log(modificado);
            if (response.error === false) {
                alert('Se modifico correctamente');
                handleAtrasClick();
            }
            if (response.error === true) {
                alert('No se pudo modificar\n' + response.message);
            }
        }
    };

    const informacionBasicaForm = () => {
        return (
            <>
                {titleForm("Informacion Basica")}
                <div className="grid grid-cols-12 gap-4 mt-4">
                    <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                        <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nombre">
                            Nombre<span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            id="nombre"
                            name="nombre"
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                            placeholder="Ingrese Usuario"
                            maxLength={charLimits.nombre}
                            onChange={handleChange}
                            value={formData.nombre}
                            readOnly={true}
                        />
                        <p className="text-sm text-gray-500 flex justify-end">{formData.nombre.length}/{charLimits.nombre}</p>
                    </div>
                    <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                        <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="direccion">
                            Direccion
                        </label>
                        <input
                            type="text"
                            id="direccion"
                            name="direccion"
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                            placeholder="Direccion"
                            maxLength={charLimits.direccion}
                            onChange={handleChange}
                            value={formData.direccion}
                        />
                        <p className="text-sm text-gray-500 flex justify-end">{formData.direccion.length}/{charLimits.direccion}</p>
                    </div>
                    <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                        <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nit">
                            Nit
                        </label>
                        <input
                            type="text"
                            id="nit"
                            name="nit"
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                            placeholder="Nit"
                            maxLength={charLimits.nit}
                            onChange={handleChange}
                            value={formData.nit}
                            readOnly={true}
                        />
                    </div>
                    <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                        <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="telefono">
                            Telefono
                        </label>
                        <input
                            type="text"
                            id="telefono"
                            name="telefono"
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                            placeholder="Telefono"
                            maxLength={charLimits.telefono}
                            onChange={handleChange}
                            value={formData.telefono}
                        />
                        <p className="text-sm text-gray-500 flex justify-end">{formData.telefono.length}/{charLimits.telefono}</p>
                    </div>
                    <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                        <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nombreUsuario">
                            Nombre Usuario
                        </label>
                        <input
                            type="text"
                            id="nombreUsuario"
                            name="nombreUsuario"
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                            placeholder="Numero Motor"
                            maxLength={charLimits.nombreUsuario}
                            onChange={handleChange}
                            value={formData.nombreUsuario}
                            readOnly={true}
                        />
                        <p className="text-sm text-gray-500 flex justify-end">{formData.nombreUsuario.length}/{charLimits.nombreUsuario}</p>
                    </div>
                    <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                        <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="fechaExpiracion">
                            Fecha Expiracion
                        </label>
                        <input
                            type="text"
                            id="fechaExpiracion"
                            name="fechaExpiracion"
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                            placeholder="Fecha Expiracion"
                            maxLength={charLimits.fechaExpiracion}
                            onChange={handleChange}
                            value={moment(formData.fechaExpiracion).format('YYYY/MM/DD')}
                            readOnly={true}
                        />
                    </div>
                </div>
            </>
        );
    };

    const titleForm = (title) => {
        return (
            <div style={styles.headerContainer}>
                <span style={styles.headerText}>{title}</span>
                <div style={styles.line}></div>
            </div>
        );
    }

    const render = () => {
        // console.log('render correo');
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (cargandoPage === false && formData === null) {
                return (
                    <div>
                        <label> Sin data</label>
                    </div>
                );
            }
            return (
                <div className="m-4">
                    <div className="flex justify-between" >
                        <h2 className="font-bold">
                            {titulo}
                        </h2>
                        <button
                            type="button"
                            className={ESTILO_BOTON_LISTAR_ATRAS}
                            onClick={handleAtrasClick}
                        >
                            ATRAS
                        </button>
                    </div>
                    {informacionBasicaForm()}
                    <div className="mt-4 flex justify-end">
                        <button
                            type="button"
                            className={ESTILO_BOTON_GENERAL_ACEPTAR}
                            onClick={handleSaveClick}
                        >
                            GUARDAR
                        </button>
                    </div>
                </div>
            );
        } catch (err) {
            console.log('Empresa render err');
            console.log(err);
            return (
                <div>
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }

    return render();
}
